import { render, staticRenderFns } from "./bibliotecadigitalasub.vue?vue&type=template&id=8f827684&"
import script from "./bibliotecadigitalasub.vue?vue&type=script&lang=js&"
export * from "./bibliotecadigitalasub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports